import { pushToDataLayer } from '../datalayer';

export function trackCheckoutTriggered({
  triggerSource,
}: {
  triggerSource: 'product_tile' | 'mini_cart' | 'my_cart' | 'attach_slideout';
}) {
  pushToDataLayer({
    event: 'checkout_triggered',
    triggerSource,
  });
}
